const industries = [
  { icon: "ri-truck-line", label: "Logistics" },
  { icon: "ri-store-2-line", label: "Retail" },
  { icon: "ri-settings-3-line", label: "Manufacturing" },
  { icon: "ri-service-line", label: "Services" },
  { icon: "ri-hand-heart-line", label: "NGOs" },
  { icon: "ri-map-pin-user-line", label: "Field Sales" },
  { icon: "ri-building-line", label: "Corporate" },
];

export default function IndustriesSection() {
  return (
    <section className="relative py-16 md:py-24 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            Built for <span className="text-emerald-accent">Every Industry</span>
          </h2>
          <p className="text-silver-300 text-base md:text-lg max-w-2xl mx-auto">
            StackMap adapts to the way your industry operates. From field teams to corporate offices, we have you covered.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto">
          {industries.map((ind) => (
            <div key={ind.label} className="glass-card p-5 md:p-6 flex flex-col items-center text-center gap-3 group">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors">
                <i className={`${ind.icon} text-2xl text-emerald-accent group-hover:scale-110 transition-transform duration-300`} />
              </div>
              <span className="text-sm md:text-base font-medium text-white">{ind.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}